<template>
  <div id="app"  @scroll="handleScroll()">
    <navigationBar :class="{ scrollbg: isScrollbg }"></navigationBar>


    <router-view></router-view>
  </div>
</template>
<script>
import NavigationBar from "./components/NavigationBar.vue";

export default {
  components: {
    navigationBar: NavigationBar,

  },
  data(){
    return{
       isScrollbg: false,
    }
  },
  computed: {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll(e) {
      let scrollTop = e.srcElement.scrollingElement.scrollTop
      if(scrollTop > 120) {
        this.isScrollbg = true
      }else {
         this.isScrollbg = false
      }

    }
  },
  created() {
    this.$router.push("/");
  },

};
</script>
<style lang="scss">
@import 'assets/fonts/index.css';
.NavigationBar {
}
.scrollbg{
  background: #000000ba;
}


a {
  text-decoration: none;
  color: #808080;
}
</style>


